<!DOCTYPE html>
<!--<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container> -->
<div class="column">
  <h2>Pazienti globali - Rettocolite ulcerosa: pazienti stabili e instabili</h2>
  <mat-spinner [diameter]="50" *ngIf="!isDataAvailable" style="left: 30%"></mat-spinner>

  <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
    <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
      <canvas id = "myChartUCStableUnstable"></canvas>
    </div>
  </div>
</div>
<div class="column">
  <ng-container *ngIf="isTableStabiliRecidivaAvailable || isTableMiglRecidivaAvailable || isTablePegRecidivaAvailable || isTableMiglRemissioneAvailable || isTablePegRemissioneAvailable || isTableStabiliRemissioneAvailable">
    <div class="mat-elevation-z8">
    <div id="myModal2" class="modal">
      <!-- Modal content -->
      <div class="modal-content" style="background-color: #FFFFFF">
        <div class ="modal-header" style="background-color: #008d8d">
          <span class="close" style="padding: 10px;" (click)="hideAllTable()">&times;</span>
          <h4 class="modal-title" style = "color: white; font-weight: bold; padding-left: 50px"> Pazienti selezionati: {{TableTitle}}</h4>
        </div>
        <div class="modal-body">
            <table mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Nome </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
              </ng-container>
              <!-- Name Column -->
              <ng-container matColumnDef="surname">
                <th mat-header-cell *matHeaderCellDef> Cognome </th>
                <td mat-cell *matCellDef="let element"> {{element.surname}} </td>
              </ng-container>
              <!-- scheda paziente -->
              <ng-container matColumnDef="card">
                <th mat-header-cell *matHeaderCellDef> Scheda </th>
                <td mat-cell *matCellDef="let patient">
                  <span><button mat-button mat-icon-button matTooltip="Visualizza scheda paziente" color="primary" (click)="openPanel(patient)"><mat-icon>perm_identity</mat-icon></button></span>
                </td>
              </ng-container>
              <!-- questionario -->
              <ng-container matColumnDef="questionnaire">
                <th mat-header-cell *matHeaderCellDef> Patient-SCCAI </th>
                <td mat-cell *matCellDef="let patient">
                  <span><button mat-button mat-icon-button matTooltip="Visualizza questionari patient-sccai" color="primary" (click)="openQuestionnaire(patient)"><mat-icon>assignment</mat-icon></button></span>
                </td>
              </ng-container>
              <!-- invia una mail -->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef> Contatta (e-mail) </th>
                <td mat-cell *matCellDef="let patient">
                  <span><a href="mailto:{{patient.email}}"><button mat-button mat-icon-button matTooltip="Invia una e-mail" color="primary"><mat-icon>email</mat-icon></button></a></span>
                </td>
              </ng-container>
              <!-- contatta tramite chat-->
              <ng-container matColumnDef="chat">
                <th mat-header-cell *matHeaderCellDef> Contatta (chat) </th>
                <td mat-cell *matCellDef="let patient">
                  <span><button mat-button mat-icon-button matTooltip="Scrivi tramite chat" color="primary" (click) = "openChat(patient)"><mat-icon> chat</mat-icon></button></span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="headElements"></tr>
              <tr mat-row *matRowDef="let row; columns: headElements;"></tr>
            </table>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                           [length]="totalSize"
                           [pageSize]="5"
                           (page)="handlePage($event)">showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
